import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import Sidebar from "../../components/SideBar";
import backendUrl from "../../apiConfig";

// Import each section component
import LinkPage from "./LinkPage";

import ThemePage from "./ThemePage";
// Import other sections as needed

const Admin = ({ isDarkMode }) => {
  const [userLinktree, setUserLinktree] = useState(null);
  const [activeSection, setActiveSection] = useState("Links"); // Track the active sidebar section
  const [username, SetUsername] = useState("")


  useEffect(() => {
    const getUsername = async () => {
      try {
        const token = localStorage.getItem("jwtToken");
        const resp = await axios.get(`${backendUrl}/user/username`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("username :::: -> ", resp);

        if (resp.status === 200) {
          SetUsername(resp.data.username);
        }
      } catch (error) {
        console.error("Error fetching username:", error);
      }
    };
    getUsername();
  }, []);



  const navigate = useNavigate();

  const fetchData = useCallback(() => {
    axios
      .get(`${backendUrl}/retrieve/html/${username}`)
      .then((response) => setUserLinktree(response.data))
      .catch((error) => console.error("Error fetching server data:", error));
  }, [username]);

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");

    if (!token) {
      navigate("/signup", { replace: true });
    } else {
      fetchData();
    }
  }, [navigate, fetchData]);

  const handleProfileChange = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className={`w-screen min-h-screen flex ${isDarkMode ? "bg-black text-white" : "bg-stone-100 text-black"}`}>
      <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} />

      {/* Left side: Conditionally render sections */}
      <div className="w-full lg:ml-[16.666667%] lg:w-2/3 flex flex-col justify-center items-center overflow-y-scroll p-4">
        {activeSection === "Links" && <LinkPage handleProfileChange={handleProfileChange} isDarkMode={isDarkMode} />}
        {activeSection === "Templates" && <ThemePage handleProfileChange={handleProfileChange} />}
        {/* Add other conditions for remaining sections */}
      </div>

      {/* Right side: Preview (no changes needed) */}
      <div className="w-full lg:w-2/5 hidden lg:flex justify-center items-center sticky top-0 mt-16  h-fit">
        {userLinktree ? (
          <div className="relative w-[320px] h-[640px] scale-90 rounded-[2.5rem] bg-white shadow-md border-4 border-gray-300">
            <iframe
              title="User Link Tree"
              srcDoc={`
                <style>
                  ::-webkit-scrollbar {
                    display: none;
                  }
                  html {
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                  }
                </style>
                ${userLinktree}
              `}
              className="w-full h-full rounded-[2.5rem]"
              style={{ overflow: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            />
          </div>
        ) : (
          <div className="relative w-[320px] h-[640px] rounded-[2.5rem] bg-white shadow-xl flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900" />
          </div>
        )}
      </div>



      {/* Mobile view preview button (no changes needed) */}
      <div className="md:hidden mx-auto fixed w-full h-12 flex justify-center items-center bottom-12">
        <div
          className={`border-2 rounded-xl px-6 flex justify-center items-center h-full z-10 hover:scale-105 duration-500 ease-linear ${isDarkMode ? "bg-slate-100 text-black" : "bg-gray-800 text-white"}`}
        >
          <a className="text-lg font-medium" href={`${backendUrl}/retrieve/html/${username}`}>
            Preview
          </a>
          <FaEye className="ml-2" />
        </div>
      </div>
    </div>
  );
};

export default Admin;
